import { render, staticRenderFns } from "./feratel.vue?vue&type=template&id=4ab79675"
import script from "./feratel.vue?vue&type=script&lang=js"
export * from "./feratel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports